import React from "react";
import { InterfaceListPageContent, InterfaceListPageStateProvider } from ".";
import { CommentDialogStateProvider } from "../dialog/comment-dialog";
import { DeploymentRequestInfomationInputDialogStateProvider } from "../dialog/deployment-request-infomation-input-dialog";

export const InterfaceListPage = () => {
  return (
    <InterfaceListPageStateProvider>
      <DeploymentRequestInfomationInputDialogStateProvider>
        <CommentDialogStateProvider>
          <InterfaceListPageContent />
        </CommentDialogStateProvider>
      </DeploymentRequestInfomationInputDialogStateProvider>
    </InterfaceListPageStateProvider>
  );
};
